import React from 'react';
import { UrlView } from './style';

const ConductAndEthics = () => {
  return (
    <UrlView src="https://master.d2uuhae8jkdsq.amplifyapp.com/eticaRedirect" />
  );
};
export default ConductAndEthics;
